// key均为路由名称

export default {
  orgFrameworkConfig: {
    getIcon(type) {
      let iconUrl;
      if (type !== undefined) {
        if (type == 1) {
          iconUrl = require('@/CommonDP/assets/doc/folder_icon.png');
        } else {
          iconUrl = require('@/CommonDP/assets/doc/folder_icon.png');
        }
      } else {
        iconUrl = require('@/CommonDP/assets/doc/folder_icon.png');
      }
      return iconUrl;
    }
  }
};
